module.exports = __webpack_public_path__ + "images/emoji/japanese_ogre.182ac547a69ae30a4602.png";